const buyMessagePrefix = "BUY";
const sellMessagePrefix = "SELL";

export { buyMessagePrefix, sellMessagePrefix };
